
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useAboutMeImages = () => {
  // Fetch banner image
  const { data: bannerImage } = useQuery({
    queryKey: ["images", "about-me-banner"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "about-me-banner")
        .order('created_at', { ascending: false })
        .limit(1)
        .single();
      
      if (error) {
        console.error("Error fetching banner image:", error);
        return null;
      }
      return data;
    },
  });

  // Fetch preaching image
  const { data: preachingImage } = useQuery({
    queryKey: ["images", "about-me-preaching"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "about-me-preaching")
        .order('created_at', { ascending: false })
        .limit(1)
        .single();
      
      if (error) {
        console.error("Error fetching preaching image:", error);
        return null;
      }
      return data;
    },
  });

  // Fetch passions image
  const { data: passionsImage } = useQuery({
    queryKey: ["images", "about-me-passions"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "about-me-passions")
        .order('created_at', { ascending: false })
        .limit(1)
        .single();
      
      if (error) {
        console.error("Error fetching passions image:", error);
        return null;
      }
      return data;
    },
  });

  // Helper function to get image URLs
  const getImageUrl = (image: any) => {
    if (image?.storage_path) {
      const { data } = supabase.storage
        .from('images')
        .getPublicUrl(image.storage_path);
      return data.publicUrl;
    }
    return null;
  };

  // Fallback images
  const fallbackImages = {
    banner: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05',
    preaching: 'https://images.unsplash.com/photo-1501854140801-50d01698950b',
    passions: 'https://images.unsplash.com/photo-1482938289607-e9573fc25ebb'
  };

  return {
    bannerImageUrl: getImageUrl(bannerImage) || fallbackImages.banner,
    preachingImageUrl: getImageUrl(preachingImage) || fallbackImages.preaching,
    passionsImageUrl: getImageUrl(passionsImage) || fallbackImages.passions
  };
};
